﻿import { SETTINGS_GET_REQUEST, SETTINGS_GET_SUCCESS, SETTINGS_GET_FAILURE } from '../../../actions/constants/types';
import { appSettingsDefault } from '../../../propTypes/entities/appSettings';

function settings(state = appSettingsDefault, action) {
  switch (action.type) {
    case SETTINGS_GET_REQUEST:
      return {
        ...state,
      };
    case SETTINGS_GET_SUCCESS:
      return {
        ...state,
        [action.response.data.settings.name]: action.response.data.settings.value,
      };
    case SETTINGS_GET_FAILURE:
    default:
      return state;
  }
}
export default settings;
